import { QuotaMetricGridContainer, InvoicePerMonthContainer } from "src/app/containers";
import { useIntl } from "react-intl";

const WriterDashboard = () => {
    const { formatMessage } = useIntl();

    return (
        <div className="dashboardContainer writerDashboardContainer">
            <h2 className="mt-5">{formatMessage({ id: "dashboard.writer.quota.title" })}</h2>
            <QuotaMetricGridContainer />

            <h2 className="mt-5">{formatMessage({ id: "dashboard.writer.invoice.title" })}</h2>
            <div className="metricsPeryearTableWrapper">
                <InvoicePerMonthContainer />
            </div>
        </div>
    );
};

export default WriterDashboard;
